import { render, staticRenderFns } from "./EditTeams.vue?vue&type=template&id=df175b4e&scoped=true&"
import script from "./EditTeams.vue?vue&type=script&lang=js&"
export * from "./EditTeams.vue?vue&type=script&lang=js&"
import style0 from "./EditTeams.vue?vue&type=style&index=0&id=df175b4e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df175b4e",
  null
  
)

export default component.exports